import { TranslationTypes } from "../../types/translationTypes";

const ptBR: TranslationTypes = {
  toggleLanguage: "EN",
  presentationOne: "Oi, meu nome é",
  presentationTwo: "Felipe França",
  presentationTree: "É um prazer tê-lo interessado em meus trabalhos.",
  skills: "Sou desenvolvedor Full Stack & UX/UI designer",
  seeProjects: "Veja meus projetos",
  knowMore: "Saiba mais sobre mim",

  aboutMe: "Sobre mim",
  aboutMeDescOne:
    "Desenvolvedor full stack focado em criar sistemas acessíveis e responsivos. Minha trajetória começou em 2022, quando fiz a transição de carreira do suporte técnico para o desenvolvimento web.",
  aboutMeDescTwo:
    "Desde então, tenho trabalhado duro e busco meu aprimoramento pessoal constantemente, me apaixonando a cada dia mais pelo que faço. Tenho experiência com tecnologias derivadas do Javascript, especialmente TypeScript, React e Next, e também com PHP voltado para hospedagens Apache. No backend já tenho experiência com Node, Nest, Java e C++. Além disso, atuo com a criação de imagens Docker e gerenciamento de bancos de dados relacionais para o deploy de aplicações.",
  aboutMeDescTree:
    "Também é relevante destacar meu interesse por produção audiovisual como hobby, no qual utilizo ferramentas como Photoshop e DaVinci Resolve. Essa experiência contribui de forma positiva para o meu trabalho com desenvolvimento frontend, especialmente em aspectos visuais e de usabilidade.",
  resume: "Veja meu curriculo",
  resumeWay: "/ffResumeptBR.pdf",

  home: "INICIO",
  projects: "PROJETOS",
  about: "SOBRE MIM",
  contact: "CONTATO",
  github: "GitHub",
  linkedin: "LinkedIn",

  info: "Expandir",
  error: "ERRO",
  backToHome: "Voltar para o inicio",

  socialMedia: "Redes sociais",

  projectLinkDesc: "Link para o repositório: ",

  projectsTitle1: "Sistema single page para calculo de TMB e controle alimentar, com base nas calorias diárias",
  projectsDate1: "30/05/2025",
  projectsDescription1:
    "Este projeto foi desenvolvido, inicialmente, para atender a uma necessidade pessoal: organizar os macronutrientes do consumo diário com o objetivo de manter uma dieta balanceada, sem depender diretamente de um nutrólogo. No entanto, vale ressaltar que a aplicação não substitui o acompanhamento profissional, pois seu uso eficaz requer um conhecimento prévio em nutrição para estruturar uma dieta sustentavél. Acessivel online em: https://felipefrancca.github.io/dieta-facil/",

  projectsTitle2: "Sistema de controle de fluxo de vendas",
  projectsDate2: "12/11/2024",
  projectsDescription2:
    "O objetivo do projeto é possibilitar a criação de vendas e os requisitos para atender a determinada venda. Os requisitos são supridos com a geração de uma compra, onde deve-se adicionar produtos previamente ao sistema, para leva-los para o carrinho e então gerar uma compra relacionada a determinada venda.",

  projectsTitle3: "Consumo de API pública",
  projectsDate3: "24/07/2024",
  projectsDescription3:
    "Praticando consumo de API contendo uma lista de personagens do filme Start wars, onde existe informações públicas e privadas, sendo possivel acessar as informações privadas através de um login com dados mocados. Acessivel online em: https://felipefrancca.github.io/listOfCharacters/",

  projectsTitle4: "Fake Trello",
  projectsDate4: "05/04/2024",
  projectsDescription4:
    "Projeto kanban desenvolvido em React.js para por em prática habilidades de drag and drop com layout baseado no site Trello. Acessivel online em: https://felipefrancca.github.io/fakeTrello/",
 
  projectsTitle5: "Página de login",
  projectsDate5: "28/10/2023",
  projectsDescription5:
    "Uma simples página de login criada para praticar noções de design e interface do usuário. Acessivel online em: https://felipefrancca.github.io/loginPage/",
};

export default ptBR;
